<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="text-xs-center">
        <v-dialog
                @keydown.esc="onCloseDialog"
                persistent
                v-model="$store.getters.completeDialog"
                width="500">
            <v-card>
                <v-card-title
                        class="headline secondary white--text justify-center"
                        primary-title
                >
                    Επιτυχής δήλωση
                </v-card-title>

                <v-card-text>
                    {{finalMessage}}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click="onCloseDialog"
                            color="primary darken-0"
                            >
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "CompleteStatementDialogModal",
        data: () => ({
        }),
        props:{
            finalMessage: String
        },
        methods: {
            onCloseDialog() {
                this.$store.commit('setCompleteDialog', false);
                this.$store.commit('setActiveDeclaration', false);
            }
        },
        computed:{
            PIN: function () {
                return this.$store.getters.statementComplete.pin
            }
        }
    }
</script>

<style scoped>

</style>